//buy now
$(document).ready(function() { $(".shopify-payment-button__button--unbranded").text("Buy Now"); }); 


//review scroll
document.addEventListener("DOMContentLoaded", function () {
    var jdgmWidget = document.querySelector(".jdgm-widget");

    if (jdgmWidget) {
        jdgmWidget.addEventListener("click", function (e) {
            e.preventDefault();

            var reviewSection = document.getElementById("judgeme_product_reviews");

            if (reviewSection) {
                reviewSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    }
});

// stickycart


document.addEventListener("click", function () {
  setTimeout(function () {

    var errorMessage = document.querySelector(".product-form__error-message-wrapper");

    if (errorMessage && errorMessage.offsetParent !== null) {
      errorMessage.style.transition = "opacity 0.4s ease";
      errorMessage.style.opacity = "0";

      setTimeout(function () {
        errorMessage.style.display = "none";
        errorMessage.style.opacity = "1";
      }, 400);
    }

  }, 6000);

});



//header megamenu
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("details.mega-menu").forEach(details => {
    const summary = details.querySelector("summary");
    let timeout;
    details.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      details.open = true;
      if (summary) summary.setAttribute("aria-expanded", "true");
    });
    details.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        details.open = false;
        if (summary) summary.setAttribute("aria-expanded", "false");
      }, 300); 
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const detailsMenus = document.querySelectorAll('header nav details');
  detailsMenus.forEach(function (menu) {
    menu.addEventListener("mouseenter", function () {
      if (window.innerWidth > 990) { 
        menu.setAttribute("open", "");
        const summary = menu.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "true");
        }
      }
    });
    menu.addEventListener("mouseleave", function () {
      if (window.innerWidth > 990) {
        menu.removeAttribute("open");
        const summary = menu.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "false");
        }
      }
    });
  });
});




// capture title immediately when page loads
document.addEventListener("DOMContentLoaded", function(){
  swymProductTitle =
    document.querySelector('.product__title h1, h1')?.innerText || "";
});

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swym) {

  swym.evtLayer.addEventListener('sw:addedtowishlist', function(e) {

    let titleFromUrl = null;
    const du = e?.detail?.d?.du || e?.detail?.du || "";

    if (du && du.includes("/products/")) {
      const handle = du.split("/products/")[1].split("?")[0];

      // convert handle -> title
      titleFromUrl = handle
        .replace(/-/g, " ")
        .replace(/\b\w/g, l => l.toUpperCase()); // lokiapad -> Lokiapad
    }

    // Step 1: Resolve title from multiple sources
    const productTitle =
      e?.detail?.dt ||
      e?.detail?.title ||
      e?.detail?.name ||
      titleFromUrl ||
      document.querySelector('.product__title')?.textContent?.trim() ||
      null;

    if (!productTitle) {
      return;
    }

    // Step 2: Wait for Swym notification render
    let attempts = 0;
    const maxAttempts = 50;

    const interval = setInterval(function() {
      attempts++;

      const titleEl = document.querySelector(
        '#swym-storefront-layout-notification .swym-storefront-layout-notification-title'
      );

      console.log(`Attempt ${attempts} - titleEl:`, titleEl);

      if (titleEl) {
        titleEl.textContent = productTitle;
        clearInterval(interval);
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }

    }, 100);

  });

});




setTimeout(function() {
  var dates = document.querySelectorAll(
    'p.jm-text[style*="--jm-body-sm-size"]'
  );
  var today = new Date();
  var customDays = [10, 20, 5, 4, 18, 25, 12, 8, 16, 22];
  for (var i = 0; i < dates.length; i++) {
    var newDate = new Date();
    newDate.setMonth(today.getMonth() - i);
    var month = ("0" + (newDate.getMonth() + 1)).slice(-2);
    var day = ("0" + customDays[i % customDays.length]).slice(-2);
    var year = newDate.getFullYear();
    dates[i].textContent = month + "/" + day + "/" + year;
  }
}, 2000);




// variant script
// (function () {

//   var isBuilding = false;
//   var activeObserver = null;

//   function formatMoney(paise) {
//     return '₹' + (paise / 100).toLocaleString('en-IN');
//   }

//   function getDiscount(price, compare) {
//     if (!compare || compare <= price) return 0;
//     return Math.round((compare - price) / compare * 100);
//   }

//   // ---- Fetch variants + attach metafields from window.__shield_meta ----
//   function fetchVariants(callback) {
//     if (window.__shield_variants && window.__shield_variants.length) {
//       callback(window.__shield_variants); return;
//     }

//     var handle = window.location.pathname.split('/products/')[1];
//     if (handle) handle = handle.split('?')[0].split('/')[0];
//     if (!handle) { callback([]); return; }

//     fetch('/products/' + handle + '.js')
//       .then(function(r) { return r.json(); })
//       .then(function(data) {
//         window.__shield_variants = data.variants || [];

//         // Attach metafields from window.__shield_meta (injected via theme.liquid)
//         var metaMap = window.__shield_meta || {};
//         window.__shield_variants.forEach(function(v) {
//           v._pack_subtitle = metaMap[String(v.id)] || '';
//         });

//         callback(window.__shield_variants);
//       })
//       .catch(function() { callback([]); });
//   }

//   // ---- Build cards ----
//   function buildCards(variants) {
//     if (isBuilding) return;
//     isBuilding = true;

//     var labels = document.querySelectorAll('.product-form__input--pill label');
//     if (!labels.length) { isBuilding = false; return; }

//     labels.forEach(function (label, i) {
//       var variant = variants[i];
//       if (!variant) return;

//       // var tablets = parseInt((variant.option1 || '').replace(/\D/g, '')) || ((i + 1) * 30);
// var optText = (variant.option1 || '');
// var match   = optText.match(/\d+/);
// var firstNum = match ? parseInt(match[0]) : (i + 1);
// var tablets;

// if (/ml|bottle/i.test(optText)) {
//   // ml / bottle product → bottles × 100
//   tablets = firstNum * 100;
// } else {
//   // tablet product → use the number as-is
//   tablets = firstNum;
// }
//       var price   = variant.price;
//       var compare = variant.compare_at_price;
//       var disc    = getDiscount(price, compare);
//       var subText = variant._pack_subtitle || '';

//       label.innerHTML = '';

//       // ---- Number ----
//       var numEl = document.createElement('span');
//       numEl.className = 'spd-card-number';
//       numEl.textContent = tablets;
//       label.appendChild(numEl);

//       // ---- Sub label — only if metafield filled ----
//       if (subText) {
//         var subEl = document.createElement('span');
//         subEl.className = 'spd-card-sub';
//         subEl.textContent = subText;
//         label.appendChild(subEl);
//       }

//       // ---- Price ----
//       if (price > 0) {
//         var priceEl = document.createElement('span');
//         priceEl.className = 'spd-card-price';
//         priceEl.textContent = formatMoney(price);
//         label.appendChild(priceEl);

//         // ---- Compare at price ----
//         if (compare && compare > price) {
//           var compareEl = document.createElement('span');
//           compareEl.className = 'spd-card-compare';
//           compareEl.textContent = formatMoney(compare);
//           label.appendChild(compareEl);
//         }

//         // ---- Discount pill ----
//         if (disc > 0) {
//           var discEl = document.createElement('span');
//           discEl.className = 'spd-card-discount';
//           discEl.textContent = disc + '% OFF';
//           label.appendChild(discEl);
//         }
//       }
//     });

//     isBuilding = false;
//     updateSelected();
//   }

//   // ---- Selected state ----
//   function updateSelected() {
//     document.querySelectorAll('.product-form__input--pill input[type="radio"]').forEach(function (radio) {
//       var label = document.querySelector('label[for="' + radio.id + '"]');
//       if (!label) return;
//       radio.checked
//         ? label.classList.add('spd-selected')
//         : label.classList.remove('spd-selected');
//     });
//   }

//   // ---- Rebuild with debounce ----
//   function rebuild() {
//     clearTimeout(window.__shield_timer);
//     window.__shield_timer = setTimeout(function () {
//       fetchVariants(function (variants) {
//         buildCards(variants);
//         attachObserver();
//       });
//     }, 60);
//   }

//   // ---- Observer on document.body ----
//   function attachObserver() {
//     if (activeObserver) {
//       activeObserver.disconnect();
//       activeObserver = null;
//     }

//     activeObserver = new MutationObserver(function (mutations) {
//       if (isBuilding) return;

//       for (var i = 0; i < mutations.length; i++) {
//         var m = mutations[i];

//         // Walk up — did change happen inside fieldset or variant-selects?
//         var target = m.target;
//         while (target && target !== document.body) {
//           if (
//             (target.classList && target.classList.contains('product-form__input--pill')) ||
//             (target.tagName && target.tagName.toLowerCase() === 'variant-selects')
//           ) {
//             rebuild();
//             return;
//           }
//           target = target.parentElement;
//         }

//         // Check added nodes
//         for (var j = 0; j < m.addedNodes.length; j++) {
//           var node = m.addedNodes[j];
//           if (node.nodeType !== 1) continue;
//           if (
//             (node.classList && node.classList.contains('product-form__input--pill')) ||
//             (node.tagName && node.tagName.toLowerCase() === 'variant-selects') ||
//             (node.querySelector && node.querySelector('.product-form__input--pill'))
//           ) {
//             rebuild();
//             return;
//           }
//         }
//       }
//     });

//     activeObserver.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }

//   // ---- Init ----
//   function init() {
//     fetchVariants(function (variants) {
//       buildCards(variants);
//       attachObserver();
//     });
//   }

//   // Dawn native event
//   document.addEventListener('variant:changed', function () {
//     rebuild();
//   });

//   // DOM ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   // Full page load safety net
//   window.addEventListener('load', function () {
//     if (!window.__shield_variants || !window.__shield_variants.length) {
//       init();
//     } else {
//       buildCards(window.__shield_variants);
//     }
//   });

// })();

// variant script
(function () {

  var isBuilding = false;
  var activeObserver = null;

  function formatMoney(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN');
  }

  function getDiscount(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((compare - price) / compare * 100);
  }

  // ---- Get product handle (works on normal + preview URLs) ----
  function getProductHandle() {
    var path = window.location.pathname;
    if (path.indexOf('/products/') !== -1) {
      var h = path.split('/products/')[1];
      if (h) return h.split('?')[0].split('/')[0];
    }
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonical.href && canonical.href.indexOf('/products/') !== -1) {
      var ch = canonical.href.split('/products/')[1];
      if (ch) return ch.split('?')[0].split('/')[0];
    }
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product && meta.product.handle) return meta.product.handle;
    } catch (e) {}
    return null;
  }

  // ---- DOM fallback: Dawn embeds variant JSON in the page ----
  function getVariantsFromDOM() {
    var el = document.querySelector(
      'variant-selects script[type="application/json"]:not([data-selected-variant]), variant-radios script[type="application/json"]:not([data-selected-variant])'
    );
    if (el) {
      try {
        var data = JSON.parse(el.textContent);
        return Array.isArray(data) ? data : (data.variants || null);
      } catch (e) {}
    }
    var sel = document.querySelector('script[type="application/json"][data-selected-variant]');
    if (sel) {
      try {
        var v = JSON.parse(sel.textContent);
        if (v && v.id) return [v];
      } catch (e) {}
    }
    return null;
  }

  // ---- Attach metafields from window.__shield_meta ----
  function attachMeta(variants) {
    var metaMap = window.__shield_meta || {};
    variants.forEach(function(v) {
      v._pack_subtitle = metaMap[String(v.id)] || '';
    });
    return variants;
  }

  // ---- Fetch variants ----
  function fetchVariants(callback) {
    if (window.__shield_variants && window.__shield_variants.length) {
      callback(window.__shield_variants); return;
    }

    var handle = getProductHandle();

    function useDOMFallback() {
      var domVariants = getVariantsFromDOM();
      if (domVariants && domVariants.length) {
        window.__shield_variants = attachMeta(domVariants);
        callback(window.__shield_variants);
      } else {
        callback([]);
      }
    }

    if (!handle) { useDOMFallback(); return; }

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var variants = data.variants || [];
        if (!variants.length) { useDOMFallback(); return; }
        window.__shield_variants = attachMeta(variants);
        callback(window.__shield_variants);
      })
      .catch(function() { useDOMFallback(); });
  }

  // ---- Build cards ----
  function buildCards(variants) {
    if (isBuilding) return;
    if (!variants || !variants.length) return;
    isBuilding = true;

    var labels = document.querySelectorAll('.product-form__input--pill label');
    if (!labels.length) { isBuilding = false; return; }

    labels.forEach(function (label, i) {
      var variant = variants[i];
      if (!variant) return;

      var optText  = (variant.option1 || '');
      var nums     = optText.match(/\d+/g) || [];
      var firstNum = nums.length ? parseInt(nums[0]) : (i + 1);
      var tablets;

      if (nums.length >= 2 && /[x×]/i.test(optText)) {
        // "2 x 100 ml bottles" → 2 × 100 = 200
        tablets = parseInt(nums[0]) * parseInt(nums[1]);
      } else if (/ml/i.test(optText)) {
        // "200 ml Bottle" → already ml
        tablets = firstNum;
      } else if (/bottle/i.test(optText)) {
        // "2 Bottles" → × 100
        tablets = firstNum * 100;
      } else {
        // "30 Tablets" → as-is
        tablets = firstNum;
      }

      var price   = variant.price;
      var compare = variant.compare_at_price;
      var disc    = getDiscount(price, compare);
      var subText = variant._pack_subtitle || '';

      label.innerHTML = '';

      var numEl = document.createElement('span');
      numEl.className = 'spd-card-number';
      numEl.textContent = tablets;
      label.appendChild(numEl);

      if (subText) {
        var subEl = document.createElement('span');
        subEl.className = 'spd-card-sub';
        subEl.textContent = subText;
        label.appendChild(subEl);
      }

      if (price > 0) {
        var priceEl = document.createElement('span');
        priceEl.className = 'spd-card-price';
        priceEl.textContent = formatMoney(price);
        label.appendChild(priceEl);

        if (compare && compare > price) {
          var compareEl = document.createElement('span');
          compareEl.className = 'spd-card-compare';
          compareEl.textContent = formatMoney(compare);
          label.appendChild(compareEl);
        }

        if (disc > 0) {
          var discEl = document.createElement('span');
          discEl.className = 'spd-card-discount';
          discEl.textContent = disc + '% OFF';
          label.appendChild(discEl);
        }
      }
    });

    isBuilding = false;
    updateSelected();
  }

  // ---- Selected state ----
  function updateSelected() {
    document.querySelectorAll('.product-form__input--pill input[type="radio"]').forEach(function (radio) {
      var label = document.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;
      radio.checked
        ? label.classList.add('spd-selected')
        : label.classList.remove('spd-selected');
    });
  }

  // ---- Rebuild with debounce ----
  function rebuild() {
    clearTimeout(window.__shield_timer);
    window.__shield_timer = setTimeout(function () {
      fetchVariants(function (variants) {
        buildCards(variants);
        attachObserver();
      });
    }, 60);
  }

  // ---- Observer on document.body ----
  function attachObserver() {
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }

    activeObserver = new MutationObserver(function (mutations) {
      if (isBuilding) return;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        var target = m.target;
        while (target && target !== document.body) {
          if (
            (target.classList && target.classList.contains('product-form__input--pill')) ||
            (target.tagName && target.tagName.toLowerCase() === 'variant-selects')
          ) {
            rebuild();
            return;
          }
          target = target.parentElement;
        }

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.classList && node.classList.contains('product-form__input--pill')) ||
            (node.tagName && node.tagName.toLowerCase() === 'variant-selects') ||
            (node.querySelector && node.querySelector('.product-form__input--pill'))
          ) {
            rebuild();
            return;
          }
        }
      }
    });

    activeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // ---- Init ----
  function init() {
    fetchVariants(function (variants) {
      buildCards(variants);
      attachObserver();
    });
  }

  document.addEventListener('variant:changed', function () {
    rebuild();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    if (!window.__shield_variants || !window.__shield_variants.length) {
      init();
    } else {
      buildCards(window.__shield_variants);
    }
  });

})();



// badges variant
// Badge names per index
var badgeNames = ['Starter', 'Most Popular', 'Best Value'];

function updateLegend() {
  var legend = document.querySelector('.product-form__input--pill legend');
  if (!legend) return;

  var checkedRadio = document.querySelector('.product-form__input--pill input[type="radio"]:checked');
  if (!checkedRadio) return;

  // Find index of checked radio
  var radios = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
  var selectedIndex = 0;
  radios.forEach(function(r, i) {
    if (r.checked) selectedIndex = i;
  });

  var badgeName = badgeNames[selectedIndex] || '';
  var optionText = checkedRadio.value || '';

  legend.innerHTML = 'CHOOSE YOUR PACK'
    + (badgeName ? ' <span class="spd-legend-badge spd-legend-badge--' + selectedIndex + '">· ' + badgeName + ' selected</span>' : '');
}